module.exports = __webpack_public_path__ + "assets/img/noVideo-green.8052c82c.svg";